import { BaseEntity } from '@base-entities';
import { BaseTransformer } from '@base-transformers';

export class LogTransformer<E extends BaseEntity = BaseEntity> extends BaseTransformer<E> {
  transformerFilterIndexTable(payload: any) {
    return payload;
  }
}
